/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoginPost200Response } from '../../models/login-post-200-response';
import { LoginPostRequest } from '../../models/login-post-request';

export interface LoginPost$Params {
      body: LoginPostRequest
}

export function loginPost(http: HttpClient, rootUrl: string, params: LoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginPost200Response>> {
  const rb = new RequestBuilder(rootUrl, loginPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoginPost200Response>;
    })
  );
}

loginPost.PATH = '/login';
